import { render, staticRenderFns } from "./AboutNew.vue?vue&type=template&id=28ed8e5d"
import script from "./AboutNew.vue?vue&type=script&lang=ts"
export * from "./AboutNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ed8e5d')) {
      api.createRecord('28ed8e5d', component.options)
    } else {
      api.reload('28ed8e5d', component.options)
    }
    module.hot.accept("./AboutNew.vue?vue&type=template&id=28ed8e5d", function () {
      api.rerender('28ed8e5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/managerDetails/AboutNew.vue"
export default component.exports